// Loads under node --test: errors.ts is import-free.
import { hasServerMessage, normalizeError } from '../../api/core/errors.ts';
import { maskId } from '../../auth/mask.ts';
import { msg, type MaybeMsg } from '../../i18n/msg.ts';

/** The Lambda error shape the teacher gateway returns: an empty `message`, the text in `errorMessage`. */
function lambdaErrorMessage(data: unknown): string {
  const value = data && typeof data === 'object' ? (data as Record<string, unknown>).errorMessage : null;
  return typeof value === 'string' ? value : '';
}

/**
 * /teacher/signin answers 500 with `Mật khẩu không khớp` for a wrong password and `Người dùng không
 * tồn tại` for an email the vendor does not hold (a wrong vendor reads the same), so only the text tells them apart.
 */
export function teacherSignInError(error: unknown, vendorId: string): MaybeMsg {
  const normalized = normalizeError(error);
  const text = (lambdaErrorMessage(normalized.data) || normalized.message).toLowerCase();
  // the text matched here is the backend's own Vietnamese reason, so these comparisons stay Vietnamese
  if (normalized.kind === 'network') return msg('errors:signIn.network');
  if (normalized.kind === 'timeout') return msg('errors:signIn.timeout');
  if (text.indexOf('mật khẩu') >= 0) return msg('errors:signIn.wrongPassword');
  if (text.indexOf('không tồn tại') >= 0 || text.indexOf('vendor') >= 0) {
    // masked: the full id lives only under "Chi tiết kỹ thuật" on /setup
    const school = vendorId ? msg('errors:signIn.schoolId', { id: maskId(vendorId) }) : '';
    return msg('errors:signIn.notFound', { school });
  }
  if (normalized.kind === 'server') return msg('errors:signIn.server');
  if (normalized.kind === 'unauthorized' || normalized.kind === 'forbidden') return msg('errors:signIn.wrongCredentials');
  if (normalized.kind === 'validation') return msg('errors:signIn.invalidFormat');
  if (hasServerMessage(normalized)) return normalized.message;
  return msg('errors:signIn.fallback');
}
